import * as React from 'react';

import Imgix from 'js/components/Imgix';

export type Props = {
  src: string;
  alt: string;
  overrideMaxHeight?: number;
  overrideMaxWidth?: number;
};

const DefaultLogoImage = ({ src, alt, overrideMaxHeight, overrideMaxWidth }: Props) => {
  return <Imgix src={src} maxWidth={overrideMaxWidth || 160} maxHeight={overrideMaxHeight || 32} alt={alt} />;
};

export default DefaultLogoImage;
